import type { SuperuserGroupMember } from '@freelancer/datastore/collections';
import { GroupMemberRoleApi } from 'api-typings/groups/groups';

export const SEARCH_GROUP_MEMBER_DEBOUNCE_TIME = 500;
export const GROUP_MEMBERS_LIMIT_PER_PAGE = 20;
export const MAX_NUMBER_OF_CSV_VALUES = 1000;

export interface SuperuserViewGroupMember extends SuperuserGroupMember {
  username: string;
}

export const GROUP_ROLE_DISPLAY_NAME_MAP = {
  [GroupMemberRoleApi.ADMIN]: 'Admin',
  [GroupMemberRoleApi.GUEST]: 'Guest',
  [GroupMemberRoleApi.MUTED]: 'Muted',
  [GroupMemberRoleApi.MEMBER]: 'Member',
  [GroupMemberRoleApi.MODERATOR]: 'Moderator',
};

export const CSV_SEPARATORS: readonly string[] = [',', '\\n'];

export enum CSVTypeOption {
  UserIds = 'User IDs',
}

export const CSV_TYPE_OPTIONS: readonly CSVTypeOption[] = [
  CSVTypeOption.UserIds,
] as const;
